import { COUNT_REFRESH_PAGE_KEY } from './constants';
import { getAccessToken } from './accessToken';

export const setCountRefreshPage = (count: number | string) => {
  const accessToken = getAccessToken();
  if (accessToken) {
    window.sessionStorage.setItem(
      COUNT_REFRESH_PAGE_KEY,
      JSON.stringify(count),
    );
  }
};

export const getCountRefreshPage = () => {
  return (
    Number(
      JSON.parse(
        window.sessionStorage.getItem(COUNT_REFRESH_PAGE_KEY) as string,
      ),
    ) || 0
  );
};

export const deleteCountRefreshPage = () => {
  window.sessionStorage.removeItem(COUNT_REFRESH_PAGE_KEY);
};
